var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 24,
    viewBox: "0 0 64 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 0H42.5C43.328 0 44 0.934873 44 2.08787V21.9132C44 23.0651 43.328 24 42.5 24H21.5C20.6712 24.0001 20 23.0651 20 21.9133V2.08787C20 0.934873 20.672 0 21.5 0Z",
    fill: "#26A6D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8647 8.34766L21.4946 15.6444H24.3319L24.6836 14.481H25.4876L25.8393 15.6444H28.9624V14.7565L29.2406 15.6444H30.8561L31.1344 14.7377V15.6444H37.6294L38.4192 14.5113L39.1587 15.6444L42.4947 15.6538L40.1172 12.0164L42.4947 8.34766H39.2104L38.4416 9.45991L37.7254 8.34766H30.6597L30.0529 10.231L29.432 8.34766H26.6006V9.2054L26.2857 8.34766H23.8647ZM24.4136 9.38381H25.7967L27.3687 14.3318V9.38381H28.8837L30.0979 12.9315L31.217 9.38381H32.7244V14.6197H31.8072L31.7997 10.5169L30.4624 14.6197H29.6419L28.2971 10.5169V14.6197H26.4101L26.0524 13.4459H24.1197L23.7627 14.6187H22.7516L24.4136 9.38381ZM33.5636 9.38381H37.2934L38.4342 11.0981L39.6117 9.38381H40.7524L39.0192 12.0154L40.7524 14.6166H39.5599L38.4192 12.8824L37.2357 14.6166H33.5636V9.38381ZM25.0864 10.2697L24.4497 12.3608H25.7225L25.0864 10.2697ZM34.4847 10.4679V11.4237H36.5194V12.4891H34.4847V13.5325H36.7669L37.8274 11.9956L36.8119 10.467H34.4847V10.4679Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.51db05822edae05229aa033d7d913793.svg";
export { ForwardRef as ReactComponent };